import VHRLeadHeading from './VHRLeadHeading';
export default VHRLeadHeading;